module.exports = __webpack_public_path__ + "assets/8f7d6b246c11eb578793533ad6db0315.mp3";